import React from 'react';
import { motion } from 'framer-motion';
import { Category } from '../types';
interface CategoryTabsProps {
  selected: Category;
  onSelect: (category: Category) => void;
}
const categories: Category[] = ['All', 'Interior', 'Art', 'Nature', 'Food', 'Fashion', 'Tech', 'Travel'];
export function CategoryTabs({
  selected,
  onSelect
}: CategoryTabsProps) {
  return <div className="w-full overflow-x-auto no-scrollbar py-4 px-4 bg-white sticky top-[72px] z-40 border-b border-gray-100" data-id="element-61">
      <div className="flex gap-3 min-w-max mx-auto max-w-[2000px]" data-id="element-62">
        {categories.map(category => <button key={category} onClick={() => onSelect(category)} className={`
              relative px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-200
              ${selected === category ? 'text-white bg-black' : 'text-gray-600 hover:bg-gray-100 bg-transparent'}
            `} data-id="element-63">
            {category}
            {selected === category && <motion.div layoutId="activeTab" className="absolute inset-0 bg-black rounded-full -z-10" transition={{
          type: 'spring',
          bounce: 0.2,
          duration: 0.6
        }} data-id="element-64" />}
          </button>)}
      </div>
    </div>;
}